import Doniraj from "components/doniraj"

export default function DonirajContainer() {
	return (
		<Doniraj />
	)
}
